const richTextEditorCentreAlignLink = (matchValue: string) => {
  const linkAttributes = {
    href: matchValue
      .split("(")
      .pop()
      ?.split(/(\)|\s)/)[0],
    text: matchValue.split("[")[1].split("]")[0],
    title: matchValue.match(/"(.)*"\)/) ? matchValue.split(' "').pop()?.split('"')[0] : undefined,
  };

  const titleAttr = !linkAttributes.title ? "" : ` title="${linkAttributes.title}"`;
  return `<a href="${linkAttributes.href}"${titleAttr}>${linkAttributes.text}</a>`;
};

export default richTextEditorCentreAlignLink;
